/**
 * 与客户端通信模块
 * @author lianghua.fu
 * @date 2022-03-29 15:13:08
 */

import EventEmitter from 'eventemitter3';
import { useStateful } from 'react-hanger';
import { useEffect } from 'react';
import { UiModal } from 'components';
import * as utils from '../utils';
import browser from '../browser';
import * as debug from '../debug';
import { getMainUrl } from '../base';
import track from '../track';

const log = debug.create('appClient');

const clientEvent = new EventEmitter();

const init = (cb) => {
  if (!browser.memeClient) {
    console.info(
      '======================\r\n非 electron 环境\r\n======================',
    );
    return;
  }
  log('init');

  window.electron.message.on((event, msg) => {
    // log('[electron msg]', msg);
    if (msg.id) {
      clientEvent.emit(msg.id, msg);
    } else {
      clientEvent.emit(msg.action, msg);
    }
    clientEvent.emit('all', msg);

    if (msg.track) {
      handleTrack(msg);
    }
  });

  clientEvent.on('track', handleTrack);

  cb && cb();
};

const handleTrack = (msg) => {
  const { gameKey, ...content } = msg.data || {};
  track.send({
    event: 'electronTrack',
    event_type: msg.action,
    content,
    gameKey,
    ...msg.track,
  });
};

/**
 *
 * @param options {
 *   action:'',
 *   data:{},
 *
 * }
 */
const call = ({
  action,
  data = {},
  onSuccess = (msg) => {},
  onFail = (msg) => {},
}) => {
  if (!browser.memeClient) {
    return;
  }
  return new Promise((resolve, reject) => {
    if (!action) {
      reject();
      console.error('action is required');
      return;
    }
    const options = {
      id: utils.getRandomString(),
      action,
      data,
    };

    clientEvent.once(options.id, (msg) => {
      if (msg.code === 1) {
        onSuccess(msg);
        resolve(msg);
      } else {
        onFail(msg);
        reject(msg);
      }
    });

    if (typeof data === 'function') {
      options.data = {};
    }

    if (action !== 'getProcessInfo') {
      log(`call【${action}】 options:`, options);
    }

    window.electron.message.send(options);
  });

  // return new Promise()
  // fn(...args);
};

const useEventListen = (name, fn = (msg) => {}) => {
  const res = useStateful(null);

  useEffect(() => {
    const _fn = (...args) => {
      const data = args.length === 1 ? args[0] : args;
      res.setValue(data);
      fn(data);
    };
    clientEvent.on(name, _fn);
    return () => {
      clientEvent.off(name, _fn);
    };
  }, [name, fn]);
  return res.value;
};

const destroy = () => {
  clientEvent.removeAllListeners();
};

const emit = (msg) => {
  clientEvent.emit(msg.action, msg);
};

const qtClient = {
  init,
  call,
  clientEvent,
  useEventListen,
  destroy,
  // setCamera,
  emit,
};

export default qtClient;
